export const ErrorText = ({ msg }: { msg: string }) => {
    return (
        <p role="alert" className="error-text">
            {msg}
        </p>
    );
};
